import Vue from 'vue'
import App from './App.vue'
import Dock from './Dock.vue'
import mainMenu from './mainMenu.vue'
import Calc from './Calc.vue'
import Author from './Author.vue'
import Plan from './Plan.vue'
import _ from 'lodash'
	


Vue.prototype._ = _
Vue.component('app-dock', Dock);
Vue.component('app-menu', mainMenu);
Vue.component('app-calc', Calc);
Vue.component('app-author', Author);
Vue.component('app-plan', Plan);

new Vue({
  el: '#app',
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js